import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder, SerializedData } from '../dto/data-model.js';

export abstract class TicketAvailabilityModifier extends DataModel {}

export class CascadingTicketAvailabilityModifier extends TicketAvailabilityModifier {
  static readonly TYPE_ID: string = 'b96773f6d9284b24a415fd4da6a32f13';

  private constructor(
    public readonly dependentTicketTemplateId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return CascadingTicketAvailabilityModifier.TYPE_ID;
  }

  static create(opts: { dependentTicketTemplateId: string }): CascadingTicketAvailabilityModifier {
    return new CascadingTicketAvailabilityModifier(opts.dependentTicketTemplateId);
  }

  static fromMap(context: SerializationContext, map: SerializedData): CascadingTicketAvailabilityModifier {
    return CascadingTicketAvailabilityModifier.create({
      dependentTicketTemplateId: MapUtils.get<string>(map, 'dependentTicketTemplateId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      dependentTicketTemplateId: this.dependentTicketTemplateId,
    };
  }

  clone(): this {
    return CascadingTicketAvailabilityModifier.create({
      dependentTicketTemplateId: this.dependentTicketTemplateId,
    }) as this;
  }

  isSame(other: TicketAvailabilityModifier): boolean {
    if(this === other) {
      return true;
    }

    if(other instanceof CascadingTicketAvailabilityModifier) {
      return other.dependentTicketTemplateId === this.dependentTicketTemplateId;
    }

    return false;
  }
}

export class CascadingTicketAvailabilityModifierBuilder extends DataModelBuilder<CascadingTicketAvailabilityModifier> {
  build(context: SerializationContext, map: SerializedData): CascadingTicketAvailabilityModifier {
    return CascadingTicketAvailabilityModifier.fromMap(context, map);
  }
}
